export const PHOTO_SPEC = { width: 300, height: 300, maxBytes: 100 * 1024 };
export const SIGNATURE_SPEC = { width: 300, height: 80, maxBytes: 60 * 1024 };

const SUPPORTED_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);
const SUPPORTED_EXT = /\.(jpe?g|png|webp)$/i;

export function isSupportedGovtJobFile(file) {
    return SUPPORTED_TYPES.has(file.type) || SUPPORTED_EXT.test(file.name || '');
}

function compressJpeg(canvas, maxBytes) {
    return new Promise((resolve, reject) => {
        let quality = 0.92;
        const attempt = () => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    reject(new Error('encode failed'));
                    return;
                }
                if (blob.size <= maxBytes || quality <= 0.4) {
                    resolve(blob);
                    return;
                }
                quality = Math.max(0.4, Math.round((quality - 0.08) * 100) / 100);
                attempt();
            }, 'image/jpeg', quality);
        };
        attempt();
    });
}

/**
 * Crop, resize, and compress an image to govt job application specs.
 */
export async function cropToSpec(image, pixelCrop, spec) {
    if (!image || !pixelCrop?.width || !pixelCrop?.height) {
        throw new Error('invalid-crop');
    }

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const sx = pixelCrop.x * scaleX;
    const sy = pixelCrop.y * scaleY;
    const sw = pixelCrop.width * scaleX;
    const sh = pixelCrop.height * scaleY;

    const canvas = document.createElement('canvas');
    canvas.width = spec.width;
    canvas.height = spec.height;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, spec.width, spec.height);
    ctx.drawImage(image, sx, sy, sw, sh, 0, 0, spec.width, spec.height);

    return compressJpeg(canvas, spec.maxBytes);
}

export async function renderPhotoPreview(image, pixelCrop) {
    return cropToSpec(image, pixelCrop, PHOTO_SPEC);
}

export async function renderSignaturePreview(image, pixelCrop) {
    return cropToSpec(image, pixelCrop, SIGNATURE_SPEC);
}

export { formatFileSize } from '../compress/compressImageEngine';
